<template>
  <div
    class="game-preview card inv"
    :class="{'stick-top': showingWithContest}">
    <loading-state :state="state"></loading-state>
    <div class="head loader"  v-if="state.isLoaded()">
      <div class="top">
        <div class="left">
          <router-link :to="{ name: 'FGGame', params:{contestKey: lcontest.key, gameKey: game.key}}">
          <h2>{{game.name}}</h2>
          </router-link>
          <div class="closetime" v-if="lpreview">
            <b>{{lpreview.game.closesAt}}</b><span> (Closing time)</span>
          </div>
        </div>
        <div class="right" v-if="lpreview">
          <router-link v-if="!game.is_closed && lpreview.my_participation" class="clean" :to="{ name: 'FGGamePlay', params:{contestKey: lcontest.key, gameKey: game.key}}">
            <span>Edit</span>
            <span>Team</span>
          </router-link>
          <router-link v-else-if="!game.is_closed" class="clean" :to="{ name: 'FGGamePlay', params:{contestKey: lcontest.key, gameKey: game.key}}">
            <span v-if="lcontest.rule">
              <span class="free" v-if="lcontest.rule.buy_in_chips === 0">Free</span>
              <span v-else>{{lcontest.rule.buy_in_chips}}$</span>
            </span>
            <small>Play</small>
          </router-link>
          <router-link v-else class="clean" :to="{ name: 'FGGame', params:{contestKey: lcontest.key, gameKey: game.key}}">
            <span>View</span>
            <span>Game</span>
          </router-link>
          <loading-state :state="playState"></loading-state>
        </div>
      </div>
      <p v-if="game.desc">{{game.desc}}</p> 
    </div>
    <div class="content"  v-if="state.isLoaded()">
      <div class="matches">
        <div
          v-for="match in lpreview.matches"
          :key="match.match.key"
          class="match-mini"
        >
          <a class="clean" :href="match.match.link" target="window">
            <div class="teams">
              <div class="team">{{match.match.teamAName}}</div>
              <div class="team">{{match.match.teamBName}}</div>
            </div>
          </a>
          <div class="info">
            <b class="time bottom-space">{{match.match.startAt | relativeShortDateTime}}</b>
            <p class="subtitle silent bottom-space">{{match.match.subtitle}}</p>
            <p class="subtitle silent bottom-space">{{match.match.season_name}}</p>
          </div>
        </div>
      </div>
      <ParticipantsPreview :preview="lpreview"/>
    </div>
    <div class="decor-holder"  v-if="state.isLoaded()">
      <div class="decor-holder__image">
        <svg-icon icon-name="game" class="decor-icon game-icon"></svg-icon>
      </div>
    </div>
  </div>
</template>
<script>
import { DataState } from '@/state'
import { GamePreview } from '@/models/fantasygame/core'
import ParticipantsPreview from '@/components/fantasygame/ParticipantsPreview'

export default {
  components: {
    ParticipantsPreview
  },
  props: {
    'contest': Object,
    'game': Object,
    'preview': Object,
    'showingWithContest': {
      type: Boolean,
      default: true
    },
    'lazyLoad': {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      lpreview: null,
      lcontest: null,
      state: DataState.newNotInit(),
      playState: DataState.newNotInit(),
      observer: null,
      intersected: false
    }
  },

  mounted () {
    if (this.lazyLoad && !this.preview) {
      this.setupLazyLoading()
    } else {
      this.fetchData()
    }
  },
  destroyed () {
    if (this.observer) {
      this.observer.disconnect()
    }
  },
  methods: {
    setupLazyLoading () {
      this.observer = new IntersectionObserver(entries => {
        if (this.intersected) { return }
        const firstEntry = entries[0]
        if (firstEntry.isIntersecting) {
          this.intersected = true
          this.observer.disconnect()
          this.onElementVisible()
        }
      })

      this.$nextTick(() => {
        if (this.observer) {
          this.observer.observe(this.$el)
        }
      })
    },

    fetchData () {
      this.state.changeToLoading()
      this.lcontest = this.contest

      if (this.preview) {
        this.lpreview = this.preview
        this.state.changeToLoaded()
      } else {
        GamePreview.fetch(this.game.key).then((resp) => {
          this.lpreview = resp
          if (!this.lcontest) {
            this.lcontest = this.lpreview.contest
          }
          this.state.changeToLoaded()
        }).catch((error) => {
          this.state.changeToError(error)
        })
      }
    },

    onElementVisible () {
      if (this.state.isNotInit()) {
        this.fetchData()
      }
    }
  }
}
</script>